// Shared date helpers for the admin pages.
export function formatDateTime(value) {
  if (!value) return '—';
  try {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    return d.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    });
  } catch (_e) {
    return value;
  }
}

export function formatRelative(value) {
  if (!value) return '—';
  try {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    const seconds = (Date.now() - d.getTime()) / 1000;
    if (seconds < 60) return 'just now';
    if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
    if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
    if (seconds < 86400 * 30) return `${Math.floor(seconds / 86400)}d ago`;
    return formatDateTime(value);
  } catch (_e) {
    return value;
  }
}

export function statusBadgeClass(status) {
  switch (status) {
    case 'new':
      return 'bg-primary/15 text-primary border-primary/25';
    case 'reviewed':
    case 'in-progress':
    case 'contacted':
      return 'bg-[hsl(var(--steel-blue)/0.15)] text-[hsl(var(--steel-blue))] border-[hsl(var(--steel-blue)/0.3)]';
    case 'interview':
      return 'bg-[hsl(45_85%_50%/0.15)] text-[hsl(38_85%_38%)] border-[hsl(38_85%_38%/0.3)]';
    case 'hired':
    case 'converted':
      return 'bg-[hsl(154_50%_36%/0.15)] text-[hsl(154_50%_28%)] border-[hsl(154_50%_28%/0.3)]';
    case 'rejected':
      return 'bg-[hsl(4_70%_45%/0.12)] text-[hsl(4_70%_45%)] border-[hsl(4_70%_45%/0.25)]';
    case 'archived':
    default:
      return 'bg-muted text-muted-foreground border-bone-2';
  }
}
